import { createSlice } from "@reduxjs/toolkit";
import { TeacherSubjectResponseDto } from "../../shared/dtos/teacherSubject/TeacherSubjectResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const teacherSubjectSlice = createSlice({
  name: "teacherSubject",
  initialState: getInitialCrudState<TeacherSubjectResponseDto>(),
  reducers: {
    ...generateCrudReducers<TeacherSubjectResponseDto>(),
  },
});

export const teacherSubjectActions = teacherSubjectSlice.actions;
export default teacherSubjectSlice.reducer;
